import React, { useState } from "react";
import clsx from "clsx";
import { useDispatch } from "react-redux";

import { TableRow, TableCell, Box, Button } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import { Delete } from "@material-ui/icons";
import CustomDialog from "@jumbo/Dashboards/AccessList/CustomDialog";
import TestsRequests from "services/tests";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles((theme) => ({
  tableRowRoot: {
    position: "relative",
    transition: "all .2s",
    borderTop: `solid 1px ${theme.palette.borderColor.main}`,
    "&:hover, &.active": {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      "& $tableCellRoot, & $titleRoot": {
        color: theme.palette.text.primary,
      },
    },
    "&:last-child": {
      borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
    },
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: `0 3px 10px 0 ${alpha(theme.palette.common.dark, 0.2)}`,
      borderTopColor: "transparent",
    },
    "&.collapse-table-row": {
      borderTop: "0 none",
      "& $tableCellRoot": {
        padding: 0,
      },
    },
    "&.active": {
      borderTop: "0 none",
      "&:hover": {
        transform: "none",
        boxShadow: "none",
      },
    },
  },
  tableCellRoot: {
    padding: 6,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.text.secondary,
    borderBottom: "0 none",
    position: "relative",
    "&:first-child": {
      paddingLeft: 24,
    },
    "&:last-child": {
      textAlign: "right",
      paddingRight: 24,
    },
  },
  tableCellFirst: {
    width: "20%",
    minWidth: "150px",
  },
  titleRoot: {
    color: theme.palette.text.secondary,
    letterSpacing: 0.25,
  },
  createIconContainer: {
    background: "transparent",
    color: theme.palette.secondary.main,
    width: "35px",
    height: "35px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    cursor: "pointer",
  },
  tableActionContainer: {
    direction: "rtl",
  },
}));

const QuizTicketListTableItem = ({ user, id, quizId }) => {
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const handleDeleteTicket = () => {
    setOpenRemoveDialog(false);
    dispatch(TestsRequests.removeSingleTicket(id));
  };

  return (
    <React.Fragment>
      <TableRow className={clsx(classes.tableRowRoot)}>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {user.personnelCode}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {user.nationalCode}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {user.fullName}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {user.phone}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableActionContainer)}
        >
          <Box display={"flex"}>
            <Box
              className={classes.createIconContainer}
              onClick={() => setOpenRemoveDialog(true)}
            >
              <Delete />
            </Box>
            <Button
              variant="contained"
              color="primary"
              style={{ marginLeft: "10px" }}
              onClick={() => history.push(`/answer/${user._id}/${quizId}`)}
            >
              پاسخ
            </Button>
          </Box>
        </TableCell>
      </TableRow>
      <CustomDialog
        text={"آیا از حذف دسترسی این مورد اطمینان دارید؟"}
        open={openRemoveDialog}
        handleClose={() => setOpenRemoveDialog(false)}
        action={handleDeleteTicket}
      />
    </React.Fragment>
  );
};

export default QuizTicketListTableItem;
